<template>
	<div>
		<iframe
			:src="$data.pathPrefix + '/ru/page/67036?' + $data.recordIdParam"
			width="100%"
			height="1300px"
			ref="iframeRef"
			style="border: 1px solid #e9eaed">
		</iframe>
	</div>
</template>

<script>
import ctrlMixins from "./../_mixins.js";
import urlUtil from "@uarm/src/util-url.js";

export default {
	name: "spc_livecharts",
	mixins: [ctrlMixins], // c_value, c_ctrlParams, c_srv_options, пропсы view_type, field_meta и так далее
	props: {
		// большая часть пропсов приезжает из ctrlMixins!
		value: {
			default: ""
		}
	},
	data() {
		const recordId = this.$route.params.recordId || 0;

		return {
			recordIdParam: recordId ? "livechart_id=" + recordId : "",
			pathPrefix: urlUtil.wizDomainProxy.getPrePathTpl(this.$route.params.vpId),
			readyCounter: 0
		};
	},
	mounted() {
		this.$nextTick(() => {
			this.setInnerValueWhenReadyBothCompAndFrame();
		});
	},
	methods: {
		sendMessage(data) {
			if (!this.$refs || !this.$refs.iframeRef) {
				console.log(" ref айфрейма отсутствует, вероятно из-за горячей перезагрузки, жми F5 и смотри на свежую");
				return;
			}
			this.$refs.iframeRef.contentWindow.postMessage(data, "*");
		},
		// айфрейм иногда грузится раньше чем компонент примонтирован и инициализированы его рефы
		// поэтому так
		setInnerValueWhenReadyBothCompAndFrame: function () {
			var vm = this;
			vm.$data.readyCounter++;

			if (vm.$data.readyCounter > 1) {
				vm.sendMessage({
					type: "setInnerValue",
					payload: vm.$props.value,
					callback_id: vm.$data.inputReadyCallbackId
				});
			}

	  // initWatchToChangeTheme(
		// 	this.$refs.iframeRef.contentWindow.document.getElementsByTagName("body")[0]
	  // )

		}
	},
	beforeCreate: function () {
		window.addEventListener("message", messageListener, false);
		var vm = this;
		function messageListener(event) {
			// event.data - данные в любом формате
			// event.origin - домен айфрейма
			// event.source - window айфрейма
			var type = event.data.type;
			var payload = event.data.payload;
			var callback_id = event.data.callback_id;
			if (event.data.sender_code === "LIVE_CHARTS") {
				if (type === "doPrompt") {
					vm.sendMessage({
						type: "execCallback",
						payload: "AAAAAA", //result,
						callback_id: callback_id
					});
				}
				if (type === "setOuterValue") {
					var objPayload = JSON.parse(payload);
					objPayload.name = document.querySelector('[test-dbcolname="name"] input').value;
					vm.$emit("input", JSON.stringify(objPayload));
				}
				if (type === "inputReady") {
					vm.$data.inputReadyCallbackId = callback_id;
					vm.$nextTick(() => {
						vm.setInnerValueWhenReadyBothCompAndFrame();
					});
				}
			}
		}
	}
};
</script>
